// Dev-only mock mode. Enabled with REACT_APP_MOCK=true (see `yarn start:mock`),
// it bypasses Auth0 and serves canned GraphQL data so the dashboard can be run
// in a browser with no Auth0 tenant and no backend. Never enabled in production.
export const MOCK_ENABLED = process.env.REACT_APP_MOCK === 'true'
